export default function({ app, error }) {
  if (!app.$planHasPermission('crud_document')) {
    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー',
    })
  }
}
